export default __webpack_public_path__ + "static/media/marauders-map-v1-01-02.429185d5.jpg";